import React, { useState, useEffect } from 'react';
import { Grid, Box } from '@mui/material';
import EventCard from './EventCard';
import { useSpring, useSpringRef, useChain, useTransition, config, animated } from "react-spring";
import { useBackdrop, openBackdrop } from '../hooks/useBackdrop';
import { useNavigate, useParams } from 'react-router-dom';


import Loading from './Loading';
import '../css/noscroll.css';
import axios from 'axios';


export default function EventBoard() {

    const { openBackdrop, closeBackdrop } = useBackdrop();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const [data, setData] = useState();

    const { loadNumber } = useParams();
    const navigate = useNavigate();


    useEffect(() => {
        setLoading(true);
        openBackdrop(
            <div>
                <Loading />
            </div>
        );

        if (loadNumber) {
            axios.get(`/api/prod/mobile_api.php?action=pull&load=${loadNumber}`)
                .then(res => {
                    let lastStopObj = res.data.stops.reduce((max, current) => current.stop_number >= max.stop_number ? current : max)


                    res.data.stops.map((e, i) => {
                        e.canArrive = false; // Set default value for canArrive
                        e.canDepart = false; // Set default value for canDepart

                        if (e.stop_number == lastStopObj.stop_number) {
                            e.lastStop = true;
                        }
                        if (e.stop_number == 1) {

                            // If the arrival time on the first stop is empty, it can be arrived at
                            if (e.arrival_date.length < 1) {
                                e.canArrive = true;
                            }
                            // If the arrival time on the first stop is filled and the departure time on the first stop is empty, it can be departed from
                            if (e.arrival_date.length > 0 && e.departure_date.length < 1) {
                                e.canDepart = true;
                            }
                        }
                        else {
                            // If the arrival time on the current stop is empty and the departure time on the previous stop is filled, it can be arrived at
                            if (e.arrival_date.length < 1 && res.data.stops[i - 1].departure_date.length > 0) {
                                e.canArrive = true;
                            }
                            // If the arrival time on the current stop is filled and the departure time on the current stop is empty, it can be departed from
                            if (e.arrival_date.length > 0 && e.departure_date.length < 1) {
                                e.canDepart = true;
                            }
                        }

                    });

                    setData(res.data);
                    setLoading(false);
                    closeBackdrop();
                })
                .catch(err => {
                    if (err?.response?.status === 404) {
                        setError('Load Number not found!')
                        setLoading(false);
                    }
                    else {
                        console.log(err)
                        navigate('/error');
                    }
                    closeBackdrop();
                })
        }
    }, []);



    if (loading) {
        return (<>

        </>)
    }
    if (error && error.length > 0) {
        return (
            <Box sx={{ typography: 'h5', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80vh' }}>
                {error}
            </Box>
        )
    }


    else {
        return (
            <Box sx={{ padding: '20px' }}>
                <Box
                    className="noscroll"
                    sx={{
                        'overflowY': 'scroll',
                        height: 'calc(100vh - 120px)',
                    }}>
                    <Grid container spacing={2} flexDirection="column" alignContent="center">
                        <Grid item xs>
                            <FadeInComponent>
                                <Box sx={{ typography: 'h5' }}>{data.load_number}</Box>
                                <Box sx={{ typography: 'body2', color: '#7d8187', textTransform: "uppercase", }}>{data.route}</Box>
                            </FadeInComponent>
                        </Grid>
                        <SlideInCards data={data} load={data} />
                    </Grid>
                </Box>
            </Box>
        );
    }
}



const FadeInComponent = ({ children }) => {
    const fadeStyles = useSpring({
        config: { ...config.stiff },
        from: { opacity: 0 },
        to: {
            opacity: 1
        },
        delay: 200,
        duration: 400,
    });

    return (
        <animated.div style={fadeStyles}>
            {children}
        </animated.div>
    )
}

const SlideInCards = ({ load }) => {
    const transitions = useTransition(load.stops, {
        config: config.gentle,
        from: { opacity: 0, transform: "translate3d(-25%, 0px, 0px)" },
        enter: { opacity: 1, transform: "translate3d(0%, 0px, 0px)" },
        leave: { opacity: 0, height: 0, transform: "translate3d(25%, 0px, 0px)" },
        keys: load.stops.map((item, index) => index),
        trail: 750 / load.stops.length,
    });

    return transitions((styles, item) => {
        return (
            <Grid item xs sx={{ marginBottom: item.lastStop ? '70px' : '5px' }}>
                <animated.div style={styles}  >
                    <EventCard event={item} load={load} />
                </animated.div>
            </Grid>
        )
    })
}